
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n'
import VueMq from 'vue-mq'
import {store} from '@store/store';
import router from '@js/routes';
import i18n from '@js/i18n';
import App from '@/App';
import Home from '@/Home';
import NswHeader from '@/NswHeader';
import NswBanner from '@/NswBanner';
import NswNews from '@/NswNews';
import NswMenu from '@/NswMenu';
import NswModule from '@/NswModule';
import Headline from '@/Headline';
import Breadcrumb from '@/Breadcrumb';
import SubCateList from '@/SubCateList';
import SubCateFooter from '@/SubCateFooter';
import MyDownload from '@/MyDownload';
import SubCateFilter from '@/SubCateFilter';
import NswSearch from '@/NswSearch';
import cssvar from '@sass/_variables.scss';
import * as HkepVueLib from 'hkep-vue-lib';
import SubCateListTableHeading from '@/SubCateListTableHeading';
import SubCateListItem from '@/SubCateListItem';
import LoginPopup from '@/LoginPopup';
import PDFViewer from '@/player/PDFViewer';
import AudioPlayer from '@/player/AudioPlayer';
import VideoPlayer from '@/player/VideoPlayer';
import Echo from "laravel-echo";

window.io = require('socket.io-client');

window.xapi_config = require("../json/xapi_config");

window.jQuery = require('jquery');


window.PhotoSwipe = require('./lib/photoswipe/photoswipe');
window.PhotoSwipeUI_Default = require('./lib/photoswipe/photoswipe-ui-default');

/**
 * Vue.use() will make the plugin globally available in the project
 */
//Use Vuex Store
Vue.use(Vuex);
//Use Vue Router
Vue.use(VueRouter);
//Use Vue i18n
Vue.use(VueI18n);
//Use Vue MQ (Media Query). Set the breakpoint names as keys, and set the breakpoint values to cssvar. Please set in ascending order in order to work.

let breakpooints = {};
breakpooints[cssvar.narrow] =Number(cssvar.narrowMax); //website main layout narrow max width
breakpooints[cssvar.wide] =Number(cssvar.wideMax); //website main layout narrow max width


Vue.use(VueMq, {
    breakpoints: breakpooints
});

window.domain = location.protocol+"//"+window.location.hostname;
window.getImageApi = window.domain+"/api/file/get_image?path=";
window.getFileApi = window.domain+"/api/learning_obj/get_file_by_id?id=";
window.getPreviewFileApi = window.domain+"/api/learning_obj/get_preview_file_by_id?id=";
window.getFileApiByPath = window.domain+"/api/learning_obj/get_file_by_path?path=";
window.pdfViewerUrl = window.domain+"/js/lib/pdfjs-prebuilt/web/viewer.html";
window.mp3Page = window.domain+"/player/mp3?id=";
window.mp4Page = window.domain+"/player/mp4?id=";


/**
 * Register components globally.
 * You can choose to register components only when needed (i.e. import them inside the parent components,
 * but since the scale of NSW frontend isn't large, we simply register most components globally here to make it more convenient.
 */
Vue.component('app', App);
Vue.component('home', Home);
Vue.component('nsw-header', NswHeader);
Vue.component('nsw-banner', NswBanner);
Vue.component('nsw-news', NswNews);
Vue.component('nsw-menu', NswMenu);
Vue.component('nsw-module', NswModule);
Vue.component('headline', Headline);
Vue.component('breadcrumb', Breadcrumb);
Vue.component('subcate-list', SubCateList);
Vue.component('subcate-footer', SubCateFooter);
Vue.component('my-download', MyDownload);
Vue.component('sub-cate-filter', SubCateFilter);
Vue.component('nsw-search', NswSearch);
// Vue.component('hkep-hello', HkepVueLib.HkepHello);
// Vue.component('hkep-world', HkepVueLib.HkepWorld);
Vue.component('hkep-loading', HkepVueLib.HkepLoading);
Vue.component('hkep-msg-pop', HkepVueLib.HkepMsgPop);
Vue.component('subcate-listtableheading', SubCateListTableHeading);
Vue.component('subcate-listitem', SubCateListItem);
Vue.component('login-popup', LoginPopup);
Vue.component('pdf-viewer', PDFViewer);
Vue.component('audio-player', AudioPlayer);
Vue.component('video-player', VideoPlayer);


//Define data to be passed to the Vue instance


/**
 * Initialize the Vue instance.
 * Pass variables so that we can access them like this.$myVar in the Vue components
 */
const app = new Vue({
    el: '#app',
    store,
    i18n,
    router,
    cssvar
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js